import { defineStore } from 'pinia'

const urlLoaderExceptions = [
  '/banks/',
  '/notifications/list_notifications/',
  '/notifications/mark_read/',
  '/products/list_products/',
  '/contacts/list_contacts',
  '/wallets',
  '/onboarding/init_liveness/',
  '/onboarding/verify_liveness/',
  '/clients/',
  '/deposit_pixes/consult_checkout_pix_status/',
  '/client_allowed_user/allowed_clients_for_authenticated_user/',
  '/payer_invoices/render_pix/',
  '/payer_invoices/generate_pix/',
  '/payer_invoices/consult_debt/',
  '/payer_invoices/render_invoice/',
  '/payer_invoices/generate_invoice/',
  '/retrieve_data/',
  'report_request_status',
]

function shouldShowLoader(url = '') {
  // Usa `includes` (não `startsWith`) de propósito: várias exceções não são
  // prefixo do path (ex.: `/retrieve_data/` é `/payer_invoices/{id}/retrieve_data/`).
  // A querystring é removida antes do match para evitar falso-positivo por um
  // parâmetro que contenha a substring de uma exceção.
  const path = url.split('?')[0]
  return !urlLoaderExceptions.some(exception => path.includes(exception))
}

export const useLoadStore = defineStore('loadStore', {
  id: 'load',
  state: () => ({
    loading: false,
    requestsPending: 0,
  }),
  actions: {
    initRequest(url) {
      this.requestsPending += 1
      if (shouldShowLoader(url)) {
        this.loading = true
      }
    },

    finishRequest() {
      this.requestsPending -= 1
      if (this.requestsPending <= 0) {
        this.requestsPending = 0
        this.loading = false
      }
    },
  },
})
